// 单文件引入方式

import Attachment from './ZuiAttachment.vue'

export default {
  install(Vue) {
    Vue.component('ZuiAttachment', Attachment)
  }
}

export { Attachment }
